import { BLOWER_PICKER_OPTIONS } from './component-catalog';
import { splitAcceptsFuel } from './system-composition';
import {
  ComponentPickerOption,
  CompositionPicks,
  CompositionSide,
  FurnaceFuel
} from './system-composition-types';

const labelFor = <T extends string>(
  options: ComponentPickerOption<T>[],
  id: T | null
): string | null =>
  id === null
    ? null
    : options.find((option) => option.id === id)?.label ?? null;

// Why a fuel pill in the want picker is disabled, named after the component
// that cannot burn it — a dead pill with no explanation reads as a bug.
// Null while the fuel is a possible answer, which always includes Electric.
// Nothing on the packaged side rules a fuel out (a packaged unit with no
// Furnace picked is an open question); reachability alone disables there.
export const fuelUnavailableReason = (
  picks: CompositionPicks,
  fuel: FurnaceFuel,
  side: CompositionSide
): string | null => {
  if (side === 'packaged' || splitAcceptsFuel(picks, fuel)) {
    return null;
  }
  const component = labelFor(BLOWER_PICKER_OPTIONS, picks.blower);
  return component === null
    ? 'This system runs on electricity only'
    : `${component} runs on electricity only`;
};
